import { Badge } from '@mantine/core';

export const BetaBadge = () => {
  return (
    <Badge size="xs" style={{ textTransform: 'initial' }}>
      Beta
    </Badge>
  );
};
